/** @jsx jsx */
import { Grid, Link, Title } from '@bottlebooks/gatsby-theme-base/src';
import Layout from '@bottlebooks/gatsby-theme-event/src/components/Layout/Layout';
import { jsx } from 'theme-ui';
import { Section } from '.';
import useLink from '../useLink';
import RegionCard from './RegionCard';

export default function SanityRegionsList({ nodes: regions, locale }) {
  const sortedRegions = [].concat(regions).sort((a, b) => {
    const aValue =
      a.association?.state?.substring(0, 4) + a.name.substring(0, 4);
    const bValue =
      b.association?.state?.substring(0, 4) + b.name.substring(0, 4);
    return aValue > bValue ? 1 : -1;
  });

  const link = useLink();

  return (
    <Layout page={{ title: 'Regions' }} locale={locale}>
      <Section variant="grey">
        <Title sx={{ paddingY: 4, textAlign: 'center' }}>
          AVAs of {sortedRegions[0].association?.state}
        </Title>
        <Grid
          gap={3}
          sx={{
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            justifyContent: 'center',
          }}
        >
          {sortedRegions.map((region) => {
            return (
              <Link
                to={link.subregion({
                  ...region.regionHierarchy,
                  subregionCode: region?.regionHierarchy?.subregionCodes?.[0],
                })}
              >
                <RegionCard region={region} height={220} />
              </Link>
            );
          })}
        </Grid>
      </Section>
    </Layout>
  );
}
